/**
 * Suspense fallback shown while a lazily loaded route chunk resolves.
 * Deliberately minimal and animation-light for industrial displays.
 */
export function PageLoader() {
  return (
    <div
      className="flex h-[60vh] items-center justify-center"
      role="status"
      aria-live="polite"
      aria-label="Loading page"
    >
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-300 border-t-blue-600" />
    </div>
  );
}
